/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddEditTicketOptionBodyBody,
    GetTicketOptionsParams,
    ReorderItemsBodyBody,
    RequestStatusResponseResponse,
    TicketOptionCreateSuccessResponseResponse,
    TicketOptionSuccessResponseResponse,
    TicketOptionsSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Add new ticket option
 */
export const addTicketOption = (
    addEditTicketOptionBodyBody: AddEditTicketOptionBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<TicketOptionCreateSuccessResponseResponse>({
        url: `/ticketoptions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addEditTicketOptionBodyBody,
        signal,
    });
};

export const getAddTicketOptionMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addTicketOption>>,
        TError,
        { data: AddEditTicketOptionBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addTicketOption>>,
    TError,
    { data: AddEditTicketOptionBodyBody },
    TContext
> => {
    const mutationKey = ['addTicketOption'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addTicketOption>>,
        { data: AddEditTicketOptionBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return addTicketOption(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddTicketOptionMutationResult = NonNullable<
    Awaited<ReturnType<typeof addTicketOption>>
>;
export type AddTicketOptionMutationBody = AddEditTicketOptionBodyBody;
export type AddTicketOptionMutationError = APIErrorResponseResponse;

/**
 * @summary Add new ticket option
 */
export const useAddTicketOption = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addTicketOption>>,
        TError,
        { data: AddEditTicketOptionBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addTicketOption>>,
    TError,
    { data: AddEditTicketOptionBodyBody },
    TContext
> => {
    const mutationOptions = getAddTicketOptionMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get ticket options matching the filters
 */
export const getTicketOptions = (params?: GetTicketOptionsParams, signal?: AbortSignal) => {
    return customInstance<TicketOptionsSuccessResponseResponse>({
        url: `/ticketoptions`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetTicketOptionsQueryKey = (params?: GetTicketOptionsParams) => {
    return [`/ticketoptions`, ...(params ? [params] : [])] as const;
};

export const getGetTicketOptionsQueryOptions = <
    TData = Awaited<ReturnType<typeof getTicketOptions>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetTicketOptionsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketOptions>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTicketOptionsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTicketOptions>>> = ({ signal }) =>
        getTicketOptions(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTicketOptions>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTicketOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTicketOptions>>>;
export type GetTicketOptionsQueryError = APIErrorResponseResponse;

/**
 * @summary Get ticket options matching the filters
 */

export function useGetTicketOptions<
    TData = Awaited<ReturnType<typeof getTicketOptions>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetTicketOptionsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketOptions>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTicketOptionsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get ticket option by id
 */
export const getTicketOption = (id: number, signal?: AbortSignal) => {
    return customInstance<TicketOptionSuccessResponseResponse>({
        url: `/ticketoptions/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetTicketOptionQueryKey = (id?: number) => {
    return [`/ticketoptions/${id}`] as const;
};

export const getGetTicketOptionQueryOptions = <
    TData = Awaited<ReturnType<typeof getTicketOption>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketOption>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTicketOptionQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTicketOption>>> = ({ signal }) =>
        getTicketOption(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTicketOption>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTicketOptionQueryResult = NonNullable<Awaited<ReturnType<typeof getTicketOption>>>;
export type GetTicketOptionQueryError = APIErrorResponseResponse;

/**
 * @summary Get ticket option by id
 */

export function useGetTicketOption<
    TData = Awaited<ReturnType<typeof getTicketOption>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketOption>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTicketOptionQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit ticket option
 */
export const editTicketOption = (
    id: number,
    addEditTicketOptionBodyBody: AddEditTicketOptionBodyBody,
) => {
    return customInstance<TicketOptionSuccessResponseResponse>({
        url: `/ticketoptions/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addEditTicketOptionBodyBody,
    });
};

export const getEditTicketOptionMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTicketOption>>,
        TError,
        { id: number; data: AddEditTicketOptionBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editTicketOption>>,
    TError,
    { id: number; data: AddEditTicketOptionBodyBody },
    TContext
> => {
    const mutationKey = ['editTicketOption'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editTicketOption>>,
        { id: number; data: AddEditTicketOptionBodyBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return editTicketOption(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditTicketOptionMutationResult = NonNullable<
    Awaited<ReturnType<typeof editTicketOption>>
>;
export type EditTicketOptionMutationBody = AddEditTicketOptionBodyBody;
export type EditTicketOptionMutationError = APIErrorResponseResponse;

/**
 * @summary Edit ticket option
 */
export const useEditTicketOption = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTicketOption>>,
        TError,
        { id: number; data: AddEditTicketOptionBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editTicketOption>>,
    TError,
    { id: number; data: AddEditTicketOptionBodyBody },
    TContext
> => {
    const mutationOptions = getEditTicketOptionMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete ticket option by id
 */
export const deleteTicketOption = (id: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/ticketoptions/${id}`,
        method: 'DELETE',
    });
};

export const getDeleteTicketOptionMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTicketOption>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteTicketOption>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['deleteTicketOption'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteTicketOption>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return deleteTicketOption(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteTicketOptionMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteTicketOption>>
>;

export type DeleteTicketOptionMutationError = APIErrorResponseResponse;

/**
 * @summary Delete ticket option by id
 */
export const useDeleteTicketOption = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTicketOption>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteTicketOption>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getDeleteTicketOptionMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Reorder ticket options
 */
export const reorderTicketOptions = (
    reorderItemsBodyBody: ReorderItemsBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/ticketoptions/reorder`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: reorderItemsBodyBody,
        signal,
    });
};

export const getReorderTicketOptionsMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof reorderTicketOptions>>,
        TError,
        { data: ReorderItemsBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof reorderTicketOptions>>,
    TError,
    { data: ReorderItemsBodyBody },
    TContext
> => {
    const mutationKey = ['reorderTicketOptions'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof reorderTicketOptions>>,
        { data: ReorderItemsBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return reorderTicketOptions(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ReorderTicketOptionsMutationResult = NonNullable<
    Awaited<ReturnType<typeof reorderTicketOptions>>
>;
export type ReorderTicketOptionsMutationBody = ReorderItemsBodyBody;
export type ReorderTicketOptionsMutationError = APIErrorResponseResponse;

/**
 * @summary Reorder ticket options
 */
export const useReorderTicketOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof reorderTicketOptions>>,
        TError,
        { data: ReorderItemsBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof reorderTicketOptions>>,
    TError,
    { data: ReorderItemsBodyBody },
    TContext
> => {
    const mutationOptions = getReorderTicketOptionsMutationOptions(options);

    return useMutation(mutationOptions);
};
